/**
 * 时间格式化工具
 * @type {{parseTime: timeUtil.parseTime, formatTime: timeUtil.formatTime}}
 * @Usage
 * 列表中的转换 parseTime: {{scope.row.created | parseTime('{y}-{m}-{d} {h}:{i}')}}
 * 详细页面 parseTime: created=parseTime(created, '{y}-{m}-{d} {h}:{i}')
 */
var timeUtil = {
  parseTime: function (time, cFormat) {
    if (arguments.length === 0) {
      return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
      date = time
    } else {
      if (('' + time).length === 10) time = parseInt(time) * 1000
      date = new Date(time)
    }
    const formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds(),
      a: date.getDay()
    }
    const timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
      let value = formatObj[key]
      if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
      if (result.length > 0 && value < 10) {
        value = '0' + value
      }
      return value || 0
    })
    return timeStr
  },
  formatTime: function (time, option) {
    time = +time * 1000
    const d = new Date(time)
    const now = Date.now()

    const diff = (now - d) / 1000

    if (diff < 30) {
      return '刚刚'
    } else if (diff < 3600) { // less 1 hour
      return Math.ceil(diff / 60) + '分钟前'
    } else if (diff < 3600 * 24) {
      return Math.ceil(diff / 3600) + '小时前'
    } else if (diff < 3600 * 24 * 2) {
      return '1天前'
    }
    if (option) {
      return this.parseTime(time, option)
    } else {
      return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
    }
  },
  monthsToNow: function (time) {
    return parseInt((new Date().getTime() - time) / (84600 * 30 * 1000))
  }
}

/**
 * Url 解析
 * @type {{urlParse: URLUtil.urlParse, paramsJson: URLUtil.paramsJson}}
 */
var urlUtil = {
  /**
     * [解析url参数]
     * @example ?id=12345&a=1
     * @return Object {id:12345,a:1}
     */
  urlParse: function () {
    let url = decodeURIComponent(window.location.search)
    let obj = {}
    let reg = /[?&][^?&]+=[^?&]+/g
    // ['?id=12345','a=1']
    let arr = url.match(reg)
    if (arr) {
      arr.forEach((item) => {
        let tempArr = item.substring(1).split('=')
        let key = decodeURIComponent(tempArr[0])
        let value = decodeURIComponent(tempArr[1])
        obj[key] = value
      })
    }
    return obj
  },
  /**
     * [解析url参数]
     * @example ?id=12345&a=1
     * @returns Object {id: "12345", a: "1"}
     */
  paramsJson: function () {
    var url = location.search
    var paramArray = []
    if (url.indexOf('?') !== -1) {
      var str = url.substr(1)
      var strs = str.split('&')
      for (var i = 0; i < strs.length; i++) {
        paramArray[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
      }
    }
    return paramArray
  }
}

export {timeUtil, urlUtil}



// WEBPACK FOOTER //
// ./src/assets/js/util.js